<template lang='pug'>
//- Payment-Success
div(:class='$style[`cc-ecpay-container`]')
  div(:class='$style[`cc-ecpay-banner`]')
    div(:class='$style[`cc-banner-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.font-doctor-theme 兌
        span.font-normal-theme 換
        span.no-wrap 成功！

      div.font-medium(:class='$style[`cc-banner-sub-title`]')
        span 請持續記錄副作用累積C幣喔！前往「交易紀錄」可以查詢訂單明細。

    div(:class='$style[`cc-banner-button`]')
      router-link(
        role='button'
        tabindex='0'
        aria-label='交易紀錄'
        :to='`/orders`'
        :class='$style[`cc-ecpay-redirect`]'
        title='交易紀錄'
      )!= '交易紀錄'
      router-link(
        role='button'
        tabindex='0'
        aria-label='繼續選購'
        :to='`/shop/subscribe`'
        :class='$style[`cc-ecpay-redirect`]'
        title='繼續選購'
      )!= '繼續選購'

    figure.graphic.graphic-pay_success(:class='$style[`cc-ecpay-graphic`]')


</template>

<script>
// import { mapGetters } from 'vuex';
// import {
//   putLinePayHandlePayment,
// } from '../../../js/restapi';

export default {
  metaInfo() {
    return {
      title: '兌換成功',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/payment/convert',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/payment/convert',
      }],
    };
  },

  // created() {
  //   console.log('QUERY', this.$route.query);

  //   if (this.$route.query) {
  //     this.axiosConfirmLinePayment(this.$route.query);
  //   }
  // },

  // data () {
  //   return {
  //   }
  // },

  // methods: {
  //   axiosConfirmLinePayment(query) {
  //     // const jwtAccess = JSON.parse(this.authJwtToken).a;
  //     const CONFIG = {
  //       headers: {
  //         'content-Type': 'application/json',
  //         // Authorization: `Bearer ${jwtAccess}`,
  //       },
  //     };

  //     const PAYMENT_DATA = {
  //       amount: query.amount,
  //       auth_id: this.loginDjangoId,
  //       transaction_id: query.transactionId,
  //       order_id: query.orderId
  //     }
  //     console.log('PAYMENT_DATA', PAYMENT_DATA)
    
  //     putLinePayHandlePayment('/confirm_payment', PAYMENT_DATA, CONFIG)
  //       .then((res) => {
  //         console.log('test', res)
  //       })
  //       .catch((err) => {
  //         console.log('error', err)
  //       })
  //   }
  // },

  // eslint-disable-next-line vue/order-in-components
  // computed: {
  //   ...mapGetters({
  //     loginDjangoId: 'user/exportUserDjangoId',
  //     // rwdType: 'global/exportRwdType',
  //     authJwtToken: 'user/exportUserJwtToken',
  //     loginStatus: 'user/exportLoginStatus',
  //     loginProfile: 'user/exportUserProfile',
  //   }),
  // }
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/info/ecpayStatus.scss';
</style>
